import React, { useEffect, useState } from 'react';
import { App, Col, Form, Row, Select } from 'antd';
import { hata } from './ortak';

/** Görüşme, plan ve lokasyon formlarının ortak alanları (il → ilçe). Harita ve konum: KonumSecici.jsx (27.10). */

const aramali = { showSearch: true, optionFilterProp: 'label', allowClear: true };

/** İl seçilince ilçeler /ilceler'den gelir; il değişince ilçe boşaltılır. */
export function IlIlceAlanlari({ form, api, iller, ilAlan = 'ProvinceID', ilceAlan = 'DistrictID', disabled }) {
  const il = Form.useWatch(ilAlan, form);
  const [ilceler, setIlceler] = useState([]);
  const { message } = App.useApp();

  useEffect(() => {
    if (!il) {
      setIlceler([]);
      return undefined;
    }
    let iptal = false;
    api.get('/ilceler', { il }).then((d) => { if (!iptal) setIlceler(d); }).catch((e) => message.error(hata(e)));
    return () => { iptal = true; };
  }, [il, api]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Row gutter={12}>
      <Col xs={24} sm={12}>
        <Form.Item name={ilAlan} label="İl">
          <Select {...aramali} options={iller} placeholder="İl seçin" disabled={disabled}
            onChange={() => form.setFieldValue(ilceAlan, null)} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12}>
        <Form.Item name={ilceAlan} label="İlçe">
          <Select {...aramali} options={ilceler} placeholder={il ? 'İlçe seçin' : 'Önce il'} disabled={disabled || !il} />
        </Form.Item>
      </Col>
    </Row>
  );
}

export { aramali };
